import { createImage } from '@gluestack-ui/image';
import { Root } from './styled-components';
export const Image = createImage({ Root });
